import { Hero } from "../components/nk/Hero";
import { EditorialMarquee } from "../components/nk/EditorialMarquee";
import { Collections } from "../components/nk/Collections";
import { AtelierDay } from "../components/nk/AtelierDay";
import { Statement } from "../components/nk/Statement";
import { Testimonials } from "../components/nk/Testimonials";
import { CtaBand } from "../components/nk/CtaBand";
import { Seo } from "../components/nk/Seo";

export default function Home() {
  return (
    <>
      <Seo
        title="NK Bridal Australia — Couture Wedding Gowns & Alterations · Perth"
        description="Couture wedding gowns & expert bridal alterations in Perth, by a renowned Brisbane seamstress. By appointment in Perth; visiting Brisbane regularly."
        path="/"
      />
      <Hero />
      <EditorialMarquee />
      <Collections preview />
      <AtelierDay />
      <Statement />
      <Testimonials />
      <CtaBand />
    </>
  );
}
